var exports = {
  "qr": "EditingMessageInput.module__footer___Sy1lLW",
  "s6": "EditingMessageInput.module__footerLink___Sy1lLW",
  "me": "EditingMessageInput.module__separator___Sy1lLW",
  "EN": "EditingMessageInput.module__editor___Sy1lLW",
};

module.exports = exports;
